<template>
  <div>
    <div id="offeredServicesForm" class="bg-white rounded px-1">
      <div class="additional-container pb-1">
        <div class="py-3 px-1 pl-c-xl">
          <icon-view
            icon="fas fa-info-circle"
            icon-background="transparent"
            icon-color="#FF7058"
            icon-size="1.0625rem"
            :title="getSectionTitle()"
            variant="custom-icon"
          />
        </div>
        <validation-observer ref="offeredServiceValidationObserver">
          <div
            v-if="!isNotPendingOrDenied()"
            class="row align-items-end font-weight-bold"
            :class="
              !this.selectedService && !this.isValid ? 'align-items-center' : ''
            "
          >
            <div class="col-md-6 col-sm-12 ml-2">
              <validation-provider
                v-slot="{ errors }"
                name="customDropDownService"
                rules="required"
              >
                <custom-drop-down
                  id="service-dropdown"
                  v-model="selectedService"
                  :clearable="false"
                  custom-error-msg="Debe seleccionar un servicio."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  label="Seleccione Datos de Servicios a Ofrecer:"
                  :options="offeredServicesOptions"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>

            <div>
              <action-button
                i="fas fa-save"
                text="Añadir"
                variant="success pl-4 pr-4"
                @click="onAddService"
              />
            </div>
          </div>
        </validation-observer>
        <div v-if="offeredServices.length > 0">
          <label
            v-if="!isNotPendingOrDenied()"
            class="color-gray-6 font-14 mt-3 ml-2 font-weight-bold"
          >
            Datos de Servicios a Ofrecer Seleccionados:
          </label>
          <custom-chips-group
            class="mt-n4"
            :disabled="isNotPendingOrDenied()"
            no-background
            :no-wrap="true"
            :object-text="'name'"
            :on-item-deleted="unSelectItem"
            :selected-items="offeredServices"
            title=""
          />
        </div>
      </div>
      <div v-if="!isNotPendingOrDenied()" class="row justify-content-end">
        <div class="mt-3 mb-3 d-flex pr-4">
          <action-button
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mr-3 pl-3 pr-3"
            @click="onCancel"
          />
          <action-button
            i="fas fa-flag-alt"
            text="Someter"
            variant="success pl-4 pr-4"
            @click="onShowAcceptTermsModal"
          />
        </div>
      </div>
    </div>
    <div class="col-12">
      <custom-modal
        cancel-text="Cancelar"
        icon="fas fa-exclamation-circle"
        is-centered
        :save-icon="'fas fa-flag pr-2'"
        save-text="Someter"
        show-cancel
        show-save
        title="Someter"
        :value="showAcceptTermsModal"
        width="850px"
        @cancel="onCancelAcceptTermHandler"
        @save="onSubmitSection"
      >
        <custom-checkbox-single-option
          id="custom-checkbox-acceptedTerms"
          v-model="acceptedTerms"
          class="font-16"
          option-text="Acepto los términos y responsabilidades"
          title="Certifico que la información ofrecida es cierta y correcta"
        />
      </custom-modal>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomModal from 'CustomModal';
import CustomCheckboxSingleOption from 'custom-checkbox-single-option';
import IconView from 'icon-view';
import ActionButton from 'ActionButton';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomChipsGroup from 'CustomChipsGroup';
import {
  getDisciplineTypeOptions as _getDisciplineTypeOptions,
  getOfferedServices as _getOfferedServices,
  submitOfferedServices as _submitOfferedServices,
} from '@/services/provider/provider-question.js';
import providerQuestionSection from '@/utils/constants/providerQuestionSection';
import providerProfileStates from '@/utils/constants/ProviderProfileStates';

export default {
  name: 'ServicesToOfferSection',
  components: {
    IconView,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    CustomChipsGroup,
    CustomModal,
    CustomCheckboxSingleOption,
  },
  mixins: [alertMixin],
  async mounted() {
    await Promise.all([this.onLoad()]);
  },
  data: () => ({
    selectedService: null,
    offeredServices: [],
    offeredServicesOptions: [],
    isValid: true,
    showAcceptTermsModal: false,
    acceptedTerms: false,
  }),
  props: {
    statusId: {
      type: Number,
      default: () => null,
    },
    academicYearId: {
      type: Number,
      default: () => null,
    },
    companyId: {
      type: Number,
      default: () => null,
    },
  },
  methods: {
    async onLoad() {
      await Promise.all([
        this.getServicesOptions(),
        this.getOfferedServices(this.academicYearId, this.companyId),
      ]);

      this.offeredServicesOptions = this.offeredServicesOptions.filter(
        (option) =>
          !this.offeredServices.some((service) => service.id === option.id)
      );
    },
    async getServicesOptions() {
      const { data: response } = await _getDisciplineTypeOptions();
      if (response) {
        this.offeredServicesOptions = response.map((item) => {
          return { name: item.name, id: item.id };
        });
      }
    },
    async getOfferedServices(academicYearId, companyId) {
      const { data: response } = await _getOfferedServices(
        academicYearId,
        companyId
      );
      if (response) {
        this.offeredServices = response;
      }
    },
    async onAddService() {
      this.isValid = await this.$refs.offeredServiceValidationObserver.validate();
      if (this.isValid) {
        this.offeredServices.push(this.selectedService);

        this.offeredServicesOptions = this.offeredServicesOptions.filter(
          (x) => x.id !== this.selectedService.id
        );

        this.$refs.offeredServiceValidationObserver.reset();
        this.selectedService = null;
      }
    },
    unSelectItem(item) {
      if (item && item.id) {
        this.offeredServices = this.offeredServices.filter(
          (x) => x.id !== item.id
        );

        this.offeredServicesOptions.push(item);
        this.offeredServicesOptions.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      }
    },
    clean() {
      this.selectedService = null;
    },
    getSectionTitle() {
      return (
        (this.isNotPendingOrDenied() ? '' : 'Añadir ') +
        'Datos de Servicios a Ofrecer'
      );
    },
    isNotPendingOrDenied() {
      return (
        this.statusId !== providerProfileStates.Pending &&
        this.statusId !== providerProfileStates.Denied
      );
    },
    async reloadOfferedServices() {
      await this.getOfferedServices(this.academicYearId, this.companyId);
      this.clean();
    },
    async onCancel() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro de que desea cancelar? Si cancela, se borrarán todos los datos que ha llenado en esta sección.`,
        'Sí',
        'No'
      );

      if (answer) {
        this.clean();
        this.$emit('on-cancel');
      } else {
        return;
      }
    },
    onCancelAcceptTermHandler() {
      this.showAcceptTermsModal = false;
      this.acceptedTerms = false;
    },
    async onShowAcceptTermsModal() {
      if (!(this.offeredServices.length > 0)) {
        await this.$refs.offeredServiceValidationObserver.validate();
        this.selectedService = null;
        this.isValid = false;
        return;
      }

      this.showAcceptTermsModal = true;
    },
    async onSubmitSection() {
      if (!this.acceptedTerms) {
        this.ShowToast(
          'Alerta',
          'Favor aceptar los términos y responsabilidades.',
          'error'
        );
        return;
      }

      const payload = {
        sectionId: providerQuestionSection.ServicesToOffer,
        companyId: this.companyId,
        academicYearId: this.academicYearId,
        statusId: providerProfileStates.Submitted,
        disciplineTypes: this.offeredServices.map((x) => x.id),
      };

      const { data: response } = await _submitOfferedServices(payload);

      if (response) {
        this.ShowToast(
          'Confirmación',
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );
        this.$emit('on-cancel');
        this.$emit('on-save');
      } else {
        this.ShowToast('Error', response?.data?.message || 'error', 'error');
      }

      this.onCancelAcceptTermHandler();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .chips-container {
  padding: 0px !important;
}

::v-deep .chips-container .inline {
  font-weight: 700;
  color: #11291b;
}
</style>
